export const LOAD_CLUSTERS_TO_MERGE = 'LOAD_CLUSTERS_TO_MERGE';

export const loadClustersToMerge = clustersToMerge => ({
  type: LOAD_CLUSTERS_TO_MERGE,
  data: clustersToMerge,
});
